import jwt                 from './jwt';
import { combineReducers } from 'redux-immutable';


export default combineReducers({jwt});



// WEBPACK FOOTER //
// ./src/modules/auth/reducers/index.js